"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeURLQueryObject = void 0;
function encodeURLQueryObject(queryObj) {
    if (typeof queryObj === 'string') {
        return queryObj;
    }
    if (typeof queryObj !== 'object' || queryObj === null) {
        return '';
    }
    return Object.entries(queryObj)
        .map(([key, value]) => `${encodeURI(key)}=${encodeURI(value)}`)
        .join('&');
}
exports.encodeURLQueryObject = encodeURLQueryObject;
//# sourceMappingURL=encodeURLQueryObject.js.map